import { defineComponent as _defineComponent } from 'vue'
import {ref, onMounted, nextTick} from 'vue';
import {signList, getTaskStatus, getMiaodouRecord, signIn, getWechatAppUrl} from '@/api/miscellaneous';
import moment from 'moment';
import {turnPages} from '@/hooks';
import {useRouter} from 'vue-router';
import {Toast, Dialog} from 'vant';
import Cookies from 'js-cookie';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckIn',
  setup(__props, { expose }) {
  expose();

const router = useRouter();

const taskList = ref<any[]>([
    {title: '登录奖励', desc: '单日最多赠送1次', miaoDou: '2', btn: '立即签到', finishBtn: '已签到', field: 'login'},
    {title: '注册成功', desc: '最多赠送1次', miaoDou: '500', btn: '立即注册', finishBtn: '已注册', field: 'enroll'},
    {
        title: '微信换群',
        desc: '每换群成功1个后赠送',
        miaoDou: '100',
        btn: '联系客服',
        finishBtn: '已邀请',
        field: '',
        type: 'window',
        path: 'https://work.weixin.qq.com/kfid/kfcdd1c5b9f6d099505',
    },
    {
        title: '邀请好友',
        desc: '每好友注册成功后赠送',
        miaoDou: '500',
        btn: '去邀请',
        finishBtn: '已邀请',
        field: '',
        type: 'wechatApp',
        path: {
            url: '/packageA/pages/tuijian2/tuijian2',
        },
    },
    {
        title: '实名认证',
        desc: '实名认证成功后赠送',
        miaoDou: '500',
        btn: '去认证',
        finishBtn: '已认证',
        field: 'hasIdCard',
        type: 'wechatApp',
        path: {
            url: 'packageA/pages/realnamerz/realnamerz',
        },
    },
    {
        title: '企业认证',
        desc: '企业认证成功后赠送',
        miaoDou: '500',
        btn: '去认证',
        finishBtn: '已认证',
        field: 'hasBusinessLicense',
        type: 'wechatApp',
        path: {
            url: 'packageA/pages/qiyeexamine/qiyeexamine',
        },
    },
    {
        title: '装修苗店',
        desc: '最多赠送1次',
        miaoDou: '10',
        btn: '去完善',
        finishBtn: '已完善',
        field: 'furnishShop',
        type: 'wechatApp',
        path: {url: 'packageA/pages/editMyShop/editMyShop'},
    },
    {
        title: '发布供应',
        desc: '单日最多赠送1次',
        miaoDou: '10',
        btn: '立即发布',
        finishBtn: '已发布',
        field: 'pubSupply',
        type: 'h5',
        path: 'ReleaseSupply',
    },
    {
        title: '发布求购',
        desc: '单日最多赠送1次',
        miaoDou: '10',
        btn: '立即发布',
        finishBtn: '已发布',
        field: 'purchaseShare',
        type: 'h5',
        path: 'ReleaseWantToBuy',
    },
    {
        title: '分享苗店',
        desc: '单日最多赠送1次',
        miaoDou: '10',
        btn: '立即分享',
        finishBtn: '已分享',
        field: 'shopShare',
        type: 'wechatApp',
        path: {url: 'pages/tabBar/platform/platform'},
    },
    {
        title: '分享供应',
        desc: '单日最多赠送1次',
        miaoDou: '10',
        btn: '立即分享',
        finishBtn: '已分享',
        field: 'supplyShare',
        type: 'wechatApp',
        path: {url: 'pages/tabBar/index/index'},
    },
    {
        title: '分享求购',
        desc: '单日最多赠送1次',
        miaoDou: '10',
        btn: '立即分享',
        finishBtn: '已分享',
        field: 'purchaseShare',
        type: 'wechatApp',
        path: {url: 'pages/tabBar/platform/platform'},
    },
]);
const spendList = ref<any[]>([
    {title: '单品报价', miaoDou: '20'},
    {title: '工程报价', miaoDou: '20'},
    {title: '查看求购电话', miaoDou: '100'},
    {title: '查看处理电话', miaoDou: '500'},
    {title: '查看供应电话', miaoDou: '2'},
]);
const taskStatus = ref<any>({});
const lastIndex = ref(0);
// const miaodouRecord = ref<any[]>([]);
const getRecordData = ref({
    page: 1,
    size: 10,
});
// turnPages()
const {
    list: miaodouRecord,
    loadMore,
    finished,
    loading,
} = turnPages({
    api: getMiaodouRecord,
});

onMounted(() => {
    let isSign = !Cookies.get('isSignIn');
    if (isSign) {
        signIn().then(res => {
            Dialog.alert({
                message: `签到成功,获得${res}苗豆`,
            }).then(() => {
                router.back();
            });
            let expires = moment().add(1, 'day').startOf('day').valueOf() - moment().valueOf();
            Cookies.set('isSignIn', '1', {expires: (expires / 1000 / 60 / 60 + 8) / 24});
            getList();
        });
    } else {
        getList();
    }
});

const active = ref(0);
const list = ref<any[]>([]);
const getList = () => {
    signList().then((res: any) => {
        list.value = res;
        lastIndex.value = res.map((el: any) => el.signIn as boolean).lastIndexOf(true);
    });
};

const getTime = (time: string) => {
    return moment(time).format('MM.DD');
};

const getStatus = () => {
    getTaskStatus().then((res: any) => {
        res.enroll = true;
        taskStatus.value = res;
    });
};
getStatus();
loadMore();

const doTheTask = (item: any) => {
    if (item.type === 'wechatApp') {
        getWechatAppUrl(item.path).then(res => {
            window.location.href = JSON.parse(res).openlink;
        });
    } else if (item.type === 'h5') {
        router.push({name: item.path});
    } else if (item.type == 'window') {
        window.location.href = item.path;
    }
};

const __returned__ = { router, taskList, spendList, taskStatus, lastIndex, getRecordData, miaodouRecord, loadMore, finished, loading, active, list, getList, getTime, getStatus, doTheTask, ref, onMounted, nextTick, signList, getTaskStatus, getMiaodouRecord, signIn, getWechatAppUrl, moment, turnPages, useRouter, Toast, Dialog, Cookies }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})